module.exports = __webpack_public_path__ + "img/web.af3eaf19.svg";